import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from '../Iconify';
import { useMemo } from 'react';
import '../../css/machines/MachineStatus.css';

const MachineNoteType = ({ status }) => {

    const displayStatus = status || 'Unknown';
    const { t } = useTranslation();

    const statusColor = useMemo(() => {
        switch (displayStatus) {
            case 'Information':
                return '#309129';
            case 'Securite':
                return '#F12525';
            case 'Maintenance':
                return '#F2B310';
            default:
                return 'black';
        }
    }, [displayStatus]);

    const statusIcon = useMemo(() => {
        switch (displayStatus) {
            case 'Information':
                return 'ri:information-line';
            case 'Securite':
                return 'si:shield-security-line';
            case 'Maintenance':
                return 'entypo:tools';
            default:
                return 'fluent-mdl2:unknown';
        }
    }, [displayStatus])

    const statusLabel = useMemo(() => {
        switch (displayStatus) {
            case 'Information':
                return 'Information';
            case 'Securite':
                return 'Sécurité';
            case 'Maintenance':
                return 'Maintenance';
            default:
                return 'Autre';
        }
    }, [displayStatus])

    return (
        <Box className='machines_status_Box' sx={{ color: statusColor, borderColor: statusColor }}>
            <Iconify icon={statusIcon} className='machines_status_icon' />
            <Typography className='machines_status'>{t(statusLabel)}</Typography>
        </Box>

    );
};

export default MachineNoteType;